import React from 'react';

const BorderTh = ({ children, colSpan = 1, className = "", bold = false }) => {
    return (
        <th
            className={[
                "border border-[#f6f6f6] px-2 py-2 text-left text-zinc-500",
                bold ? "font-bold!" : "font-normal!",
                className
            ].join(" ")}
            colSpan={colSpan}
        >
            {children}
        </th>
    );
};

export default BorderTh;